import React, { useState } from 'react';

import { Scheduler } from '../components';
import { useParams } from 'react-router-dom';

const Start: React.FC = () => {
  return (<Scheduler />);
}

export default Start;
